module.exports = __webpack_public_path__ + "static/assets/2a02c62c52c4d6508adb6b31bc9118b6.svg";